(() => {
  if (window.ClutchLoopShopSelector) return;
  const instances = new Map();

  function initCard(card, ac) {
    const data = card.querySelector('[data-variants]');
    if (!data) return;
    let variants; try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    const ci = Number(card.querySelector('[data-color-index]')?.dataset.colorIndex ?? -1);
    const select = card.querySelector('[data-select]');
    const swatches = [...card.querySelectorAll('[data-swatch]')];
    const priceEl = card.querySelector('[data-price]');
    const compareEl = card.querySelector('[data-compare]');
    const soldEl = card.querySelector('[data-soldout]');
    // Preserve links for older installed markup, without restoring its action label.
    const legacyCta = card.querySelector('[data-cta]');
    if (legacyCta) legacyCta.hidden = true;
    const waitlistUrl = card.dataset.waitlistUrl || legacyCta?.dataset.waitlistUrl;
    const img = card.querySelector('[data-image]');
    const links = card.querySelectorAll('[data-link]');

    const apply = (v) => {
      if (!v) return;
      priceEl.textContent = v.price; // pre-rendered by Shopify money filter
      if (compareEl) { compareEl.hidden = !v.compare; compareEl.textContent = v.compare || ''; }
      if (soldEl) soldEl.hidden = true;
      links.forEach((a) => { a.href = !v.available && waitlistUrl ? waitlistUrl : v.url; });
      if (img && v.image && img.getAttribute('src') !== v.image) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = v.image; }
      card.dataset.current = String(v.id);
      if (select) select.value = String(v.id);
      if (ci >= 0 && swatches.length) {
        const hit = swatches.some((s) => s.dataset.swatch === v.options[ci]);
        swatches.forEach((s, i) => { const on = hit ? s.dataset.swatch === v.options[ci] : i === 0; s.setAttribute('aria-checked', String(on && hit)); s.tabIndex = on ? 0 : -1; });
      }
    };
    const current = () => variants.find((v) => String(v.id) === (select ? select.value : card.dataset.current));

    swatches.forEach((s) => s.addEventListener('click', () => {
      const value = s.dataset.swatch, cur = current();
      const same = variants.filter((v) => v.options[ci] === value);
      const keep = cur && same.find((v) => v.options.every((o, i) => i === ci || o === cur.options[i]));
      apply((keep && keep.available && keep) || same.find((v) => v.available) || keep || same[0]);
    }, { signal: ac.signal }));
    swatches.forEach((s, i) => s.addEventListener('keydown', (e) => {
      const n = swatches.length; let t = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') t = (i + 1) % n;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') t = (i - 1 + n) % n;
      else if (e.key === 'Home') t = 0;
      else if (e.key === 'End') t = n - 1;
      else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); s.click(); return; }
      if (t < 0) return;
      e.preventDefault(); swatches[t].focus(); swatches[t].click();
    }, { signal: ac.signal }));
    select?.addEventListener('change', () => apply(current()), { signal: ac.signal });
  }

  function init(root) {
    destroy(root);
    const ac = new AbortController();
    instances.set(root, ac);
    root.querySelectorAll('[data-card]').forEach((c) => initCard(c, ac));
    const track = root.querySelector('[data-track]');
    const dots = [...root.querySelectorAll('[data-dot]')];
    if (!track || !dots.length) return;
    const cards = [...track.children];
    const centerOf = (c) => c.offsetLeft - cards[0].offsetLeft + parseFloat(getComputedStyle(track).paddingLeft || 0) + c.offsetWidth / 2;
    const isGrid = () => matchMedia('(max-width:749px)').matches && root.dataset.mobileLayout === 'grid';
    const goTo = (i) => { const c = cards[i]; if (c && !isGrid()) track.scrollTo({ left: centerOf(c) - track.clientWidth / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); };
    let raf = 0;
    const sync = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => {
      const mid = track.scrollLeft + track.clientWidth / 2; let idx = 0, nearest = Infinity;
      cards.forEach((c, i) => {
        const distance = Math.abs(centerOf(c) - mid);
        if (distance < nearest) { nearest = distance; idx = i; }
        c.style.setProperty('--clss-scale', isGrid() ? '1' : String(1 - .14 * Math.min(1, distance / (c.offsetWidth + 2))));
      });
      dots.forEach((d, i) => { if (i === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }); };
    track.addEventListener('scroll', sync, { passive: true, signal: ac.signal });
    dots.forEach((d) => d.addEventListener('click', () => goTo(Number(d.dataset.dot)), { signal: ac.signal }));
    const observer = new ResizeObserver(sync); observer.observe(track); sync();
    ac.signal.addEventListener('abort', () => { cancelAnimationFrame(raf); observer.disconnect(); });
    root._clssGoTo = goTo; root._clssCards = cards;
  }
  function destroy(root) { instances.get(root)?.abort(); instances.delete(root); }
  const all = (scope) => (scope || document).querySelectorAll('[data-cl-shopsel]').forEach(init);

  window.ClutchLoopShopSelector = { init, destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => all()); else all();
  document.addEventListener('shopify:section:load', (e) => all(e.target));
  document.addEventListener('shopify:section:unload', (e) => e.target.querySelectorAll('[data-cl-shopsel]').forEach(destroy));
  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.closest('[data-cl-shopsel]'); if (!root || !root._clssGoTo) return;
    const i = root._clssCards.indexOf(e.target); if (i >= 0) root._clssGoTo(i);
  });
})();
